var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-card',{attrs:{"title":_vm.project_title,"size":"small"}},[_c('div',{style:({ height: _vm.height, width: _vm.width }),attrs:{"id":_vm.project_title}})])
}
var staticRenderFns = []

export { render, staticRenderFns }